module.exports = __webpack_public_path__ + "static/media/aspectinteriors.5a64f936.png";